import { useQuery } from "@apollo/client/react";
import { PublicProductDocument } from "@/generated/graphql";
import { isGraphQLNotFound } from "@/lib/graphqlErrors";
import type { PublicProduct } from "@/types/models";

export function usePublicProduct(
  storeSlug: string | undefined,
  productSlug: string | undefined
) {
  const { data, loading, error, refetch } = useQuery(PublicProductDocument, {
    variables: {
      storeSlug: storeSlug!,
      productSlug: productSlug!,
    },
    fetchPolicy: "cache-and-network",
    skip: !storeSlug || !productSlug,
  });

  const product: PublicProduct | null = data?.publicProduct ?? null;
  const notFound = !loading && (isGraphQLNotFound(error) || (!product && !!error));

  return {
    product,
    loading,
    error,
    notFound,
    refetch,
  };
}
